import React, { useContext } from "react";
import { Stack, Alert, Grid } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  addUserToClinicResolver,
  parseClinicDto,
  submitUserToClinicDefault,
} from "./utils/AddUserToClinicFunctions";
import EmployeeInfoForm from "../../../master/clinics/form/EmployeeInfoForm";
import { useParams } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { GlobalDataContext } from "../../../../contexts/GlobalData";
import { ADD_EMPLOYEE_TO_CLINIC } from "../../../../enums/PermissionTitles";
import { ToggleDrawerContext } from "../../../../contexts/ToggleDrawer";
import { EMPLOYEES } from "../../../../enums/QueryKeys";
import useSubmit from "../../../master/species/hooks/useSubmit";
import ConfirmAndCancelButtons from "../../../../components/buttons/ConfirmAndCancelButtons";

export default function AddUserToClinic() {
  const { t } = useTranslation();
  const { id: clinicId } = useParams();
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const methods = useForm({
    defaultValues: submitUserToClinicDefault(),
    resolver: zodResolver(addUserToClinicResolver(t)),
  });
  const [isOpen, setIsOpen] = useContext(ToggleDrawerContext);
  const hasPermission = isPermissionAllowed(ADD_EMPLOYEE_TO_CLINIC);

  const url = "/user/clinic";
  const submittion = useSubmit(null, url, EMPLOYEES, [EMPLOYEES]);

  async function submitData(data) {
    if (hasPermission) {
      const res = await submittion.submitCallback(
        parseClinicDto(data, clinicId)
      );
      if (res) {
        setIsOpen(false);
      }
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(submitData)}>
        <Stack spacing={5}>
          <Alert severity="info">{t("AddEmployeeEmailNotice")}</Alert>
          <EmployeeInfoForm />
          <Grid container>
            <Grid item xs={12}>
              <ConfirmAndCancelButtons
                confirmTitle="Save"
                cancelTitle="Cancel"
                onCancel={() => setIsOpen(false)}
                confirmButtonType="submit"
              />
            </Grid>
          </Grid>
        </Stack>
      </form>
    </FormProvider>
  );
}